<template>
  <div
    @click="handleNavigation"
    v-html="userBlock" />
</template>

<script>
import { ref, useFetch } from '@nuxtjs/composition-api';
import { useContent } from '~/composables';

export default {
  setup() {
    const userBlock = ref(null);
    const { loadBlocks } = useContent();

    useFetch(async () => {
      const newBlock = await loadBlocks({ identifiers: ['header_left_links'] });
      const blockValue = newBlock.map((items) => items);
      userBlock.value = blockValue?.[0].content;
    });
    return {
      userBlock,
    };
  },
  methods: {
    handleNavigation(event) {
      const target = event.target.closest('[data-link]');
      if (target) {
        event.preventDefault();
        this.$router.push(target.dataset.link);
      }
    },
  },
};
</script>
